import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { Head } from '@_/components';
import { getReactQueryOptions } from '@_/utils-frontend';
import { publicApiQueryClient } from '#src/api.ts';
import { BookingConfirmationPage } from '#src/pages/BookingConfirmationPage/index.ts';

export const Route = createFileRoute('/{-$locale}/_auth/booking-confirmation_/$orderId')({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const { queryClient } = context;
    const { orderId } = params;
    await Promise.all([
      queryClient.ensureQueryData(orderQueryOptions({ orderId })),
      queryClient.ensureQueryData(bookingsQueryOptions({ orderId }))
    ]);
  }
});

function RouteComponent() {
  const { orderId } = Route.useParams();
  const intl = useIntl();

  const bookingsQuery = useSuspenseQuery(bookingsQueryOptions({ orderId }));
  const bookings = bookingsQuery.data.data;

  return (
    <>
      <Head>
        <title>
          {intl.formatMessage({
            id: 'head.booking-confirmation-page',
            defaultMessage: 'Booking confirmed'
          })}
        </title>
      </Head>
      <BookingConfirmationPage bookings={bookings} />
    </>
  );
}

function orderQueryOptions({ orderId }: { orderId: string }) {
  return getReactQueryOptions(publicApiQueryClient.orders.get, {
    params: { id: orderId }
  });
}

function bookingsQueryOptions({ orderId }: { orderId: string }) {
  return getReactQueryOptions(publicApiQueryClient.bookings.list, {
    query: { orderId }
  });
}
